import type { SalesOrderLineFormValues, SalesOrderLogisticsFormValues } from "./schemas"

import type { ComputedProductStatus } from "@/graphql/codegen/graphql"

// AK-6130 — Product Selection Modal tabs
export enum ProductSelectionTab {
  Approved = "APPROVED",
  Quoted = "QUOTED",
  LinkedCompanies = "LINKED_COMPANIES",
  Sampled = "SAMPLED",
}

export enum SalesOrderDialogType {
  UploadDocuments = "uploadDocuments",
  ViewDocuments = "ViewDocuments",
  UpdateStatus = "UpdateStatus",
  CancelSalesOrder = "CancelSalesOrder",
}

export interface SelectedProduct {
  productId: number
  label: string
  publicId: string | null
  externalSystemId: string | null
  customerCode: string | null
  customerDescription: string | null
  companyProductDescription: string | null
  supplierName: string | null
  computedProductStatus: ComputedProductStatus | null
  packageUsWeightUom: string | null
  packageMetricWeightUom: string | null
  packageUsWeight: number | null
  packageMetricWeight: number | null
  packagesPerPallet: number | null
  palletUsWeight: number | null
  palletUsWeightUom: string | null
  palletMetricWeight: number | null
  palletMetricWeightUom: string | null
  noteCount: number
}

export type SalesOrderPricingHeader = Pick<
  SalesOrderLogisticsFormValues,
  "incoterms" | "incotermsLocationId" | "freightTerms" | "shipFromWarehouseAreaId"
>

export interface SalesOrderPricingParams {
  customerId: string
  productIds: number[]
  header: SalesOrderPricingHeader
  lines: SalesOrderLineFormValues[]
  freightLine?: Pick<NonNullable<SalesOrderLogisticsFormValues["freightLine"]>, "quantity" | "pricePerUom"> | null
}
